const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export function createHeaders(
  ...headersList: Array<HeadersInit | undefined>
): Headers {
  const headers = new Headers();

  [defaultHeaders, ...headersList].forEach((headersInit) => {
    if (headersInit) {
      new Headers(headersInit).forEach((value, key) => {
        headers.set(key, value);
      });
    }
  });

  return headers;
}
